import { render, staticRenderFns } from "./companyMail.vue?vue&type=template&id=34777ce8&scoped=true"
import script from "./companyMail.vue?vue&type=script&lang=js"
export * from "./companyMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34777ce8",
  null
  
)

export default component.exports